import { ChangeDetectionStrategy, Component, Injector, OnDestroy, OnInit } from "@angular/core";
import { EMPTY, Observable, Subject } from "rxjs";
import { catchError, map, shareReplay, startWith, takeUntil } from "rxjs/operators";
import { ApexChart, ApexLegend, ApexNonAxisChartSeries, ApexPlotOptions } from "ng-apexcharts";
import { PieSeries } from "../api/proxies";
import { StatsService } from "../services/stats.service";

export type ChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    labels: string[];
    legend: ApexLegend;
    plotOptions: ApexPlotOptions;
    colors: string[];
};

@Component({
    selector: "mobile-summary",
    templateUrl: "./summary.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileSummaryComponent implements OnInit, OnDestroy {
    private _unsubscribeAll = new Subject<void>();

    loading$!: Observable<boolean>;

    chartOptions$!: Observable<Partial<ChartOptions>>;

    monthlyActiveUsersChartOptions$!: Observable<Partial<ChartOptions>>;

    constructor(private statsService: StatsService) {}

    ngOnInit(): void {
        const mobile$ = this.statsService.stats$.pipe(
            map(({ mobile }) => mobile),
            shareReplay({ bufferSize: 1, refCount: true }),
            takeUntil(this._unsubscribeAll)
        );

        this.loading$ = mobile$.pipe(
            map(() => false),
            startWith(true),
            catchError(() => EMPTY)
        );

        this.chartOptions$ = mobile$.pipe(
            map((resp) => resp.installations ?? []),
            map((data) => this.buildDonutOptions(data))
        );

        this.monthlyActiveUsersChartOptions$ = mobile$.pipe(
            map((resp) => resp.monthlyActiveUsers ?? []),
            map((data) => this.buildDonutOptions(data))
        );
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    private buildDonutOptions(data: PieSeries[]): Partial<ChartOptions> {
        return {
            chart: { type: "donut", animations: { enabled: false } },
            series: data.map((i) => i.value),
            labels: data.map((i) => i.label),
            colors: data.map((i) => i.color),
            legend: { position: "bottom", horizontalAlign: "center" },
            plotOptions: {
                pie: {
                    donut: {
                        size: "60%",
                        labels: {
                            show: true,
                            total: { showAlways: false, show: true, color: "#000000" },
                        },
                    },
                },
            },
        };
    }
}
